import { React, useEffect, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import apiService from '../../services/apiServices';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import Paper from '@mui/material/Paper';
import TopActions from '../actions/TopActions';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import Modal from '../actions/Modal';
import Toast from '../actions/Toasts';
import Moment from 'react-moment';
import ButtonGroup from '@mui/material/ButtonGroup';
import Button from '@mui/material/Button';
import { spacing } from '@mui/system';
import Typography from '@mui/material/Typography';
import AddNew from './AddNew';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useParams,
  } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import SelectController from '../../controllers/SelectController';
import InputController from '../../controllers/InputController';

const MonthSalariesList = (props) => {
    let { month, year } = useParams();
    const [salaries, setSalaries] = useState([]);
    const [salaries1, setSalaries1] = useState([]);
    const [modal, setModal] = useState({});
    const [rowId, setRowId] = useState({});
    const alert = { open: false, message: '', variant: '' };
    const [toast, setToast] = useState(alert);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [workers, setWorkers] = useState([]);
    const [months, setMonths] = useState([]);
    const {
      register,
      handleSubmit,
      setValue,
      watch,
      control,
      formState: { errors },
    } = useForm();

    const getYear = (date) => {
      return new Date(date).getFullYear()
    }

    const obj = {Advances: 5, FirstName: "Besart", Id: 0, LastName: "Morina", Month: 2, Salary: 300, SalaryDate: "2022-01-07T00:00:00.000Z"}

    const getSalaries = () => {
        apiService()
            .get('salaries').then((response) => {
                if (response.success) {
                    let products = response.data;
                    products = products.filter(p => p.Month == month && getYear(p.SalaryDate) == year)
                    console.log('prd: ', products)
                    setSalaries(countItems(products));
                    
                    //grupBy(products)
                } else {
                    //alert('Error:' + response.errorMessage);
                }
            });
    }

    const getWorkers = () => {
      apiService().get('selectworker')
        .then((response) => {
            if (response.success) {
              setWorkers(response.data);
            } else {
              alert('Error:' + response.errorMessage);
            }
          });
    }

    const getMonths = () => {
      apiService().get('months')
        .then((response) => {
              if (response.success) {
                setMonths(response.data);
                console.log('mooooo', response)
              } else {
                alert('Error:' + response.errorMessage);
              }
            });
    }

    const onRowClick = (no) => {
      let rowItem = [...salaries]
      rowItem.forEach(i => i.editMode = false);
      rowItem[no-1].editMode = !rowItem[no-1].editMode;
      setSalaries(rowItem);
    }

    const addRow = () => {
      let newItem = obj
      newItem.no = Math.max(...salaries.map(o => o.no), 0) + 1
      const newState = [...salaries, newItem];
      setSalaries(countItems(newState))
    }

    const deleteRow = (rowId) => {
      let arrayCopy = [...salaries]
      let item = arrayCopy.find(i => i.no === rowId);
      item.status = -1; //status.deleted;
      //arrayCopy = arrayCopy.filter((row) => row.status !== -1);
      const newArr = [countItems(arrayCopy)]
      setSalaries(countItems(arrayCopy))
    }

    const countItems = (arr) => {
      let count = 1;
      arr.forEach(i => { i.no = count; count++ });
      return arr;
    }

    const cimi = (e) => {
      console.log(e)
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const openModal = (id) => {
        setModal({
          open: true,
          tittle: 'Delete',
          message: 'Do you want to delete this row?',
        });
        setToast({ open: false });
        setRowId(id);
    };

    useEffect(()=> {
      console.log('month, year', month, year)
        getSalaries();
        getWorkers();
        getMonths();
    }, [])
    return (
        <div>
        <TopActions newHref="/salarieslist/addsalary" saveHref="/dashboard/" />
        <Typography variant="h6" gutterBottom>
              Lista e pagave për muajin: {months.find(m => m.id == month)?.name}, {year}
        </Typography>
        <TableContainer component={Paper}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell style={{width: '20px'}}>Edit</TableCell>
              <TableCell>Nr</TableCell>
              <TableCell>Punëtori</TableCell>
              <TableCell>Muaji</TableCell>
              <TableCell style={{width: '80px'}}>Data</TableCell>
              <TableCell>Paga</TableCell>
              <TableCell>Avanci</TableCell>
              <TableCell>Orët shtesë</TableCell>
              <TableCell>Pagesa për Orë shtesë 1</TableCell>
              <TableCell>Bonuset</TableCell>
              <TableCell>Totali</TableCell>
              <TableCell>Add/Remove</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {salaries
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((w, index) => ( w.status !== -1 &&
                <TableRow key={w.Id+index}>
                  <TableCell>
                    <ButtonGroup size="small">
                      <Link to={`/salarieslist/editsalary/${w.Id}`}>
                        <Button>
                          <EditIcon />
                        </Button>
                      </Link>
                      {/* <Button onClick={() => openModal(w.Id)}>
                        <DeleteIcon />
                      </Button> */}
                    </ButtonGroup>
                  </TableCell>
                  <TableCell>{index + 1}</TableCell>
                  {w.editMode ? 
                    <TableCell><SelectController onChangeProp={(e) => cimi(e)} error={errors.WorkerId} control={control} options={workers} name="WorkerId" register={{ ...register('WorkerId') }}/></TableCell>
                    :
                    <TableCell onClick={function () { onRowClick(w.no) }}>{w.FirstName}</TableCell>
                  }
                  {w.editMode ?
                    <TableCell><SelectController error={errors.Month} control={control} options={months} name="Month" register={{ ...register('Month') }} /></TableCell>
                    :
                  <TableCell onClick={function () { onRowClick(w.no) }}>{months.find(m => m.id == w.Month)?.name}</TableCell>
                  }     
                  {
                    w.editMode ? 
                    <TableCell>
                      <InputController error={errors.SalaryDate} control={control} type="date" register={{ ...register('SalaryDate') }} />
                    </TableCell>
                    :
                    <TableCell onClick={function () { onRowClick(w.no) }}>
                      <Moment format="DD/MM/YYYY">{w.SalaryDate}</Moment>
                    </TableCell>
                  }
                  {
                    w.editMode ? 
                    <TableCell><InputController error={errors.Salary} control={control} symbol="€" register={{ ...register('Salary') }} /></TableCell>
                    :
                    <TableCell onClick={function () { onRowClick(w.no) }}>
                      {new Intl.NumberFormat('en-GB', {
                        style: 'currency',
                        currency: 'EUR',
                      }).format(w.Salary)}
                    </TableCell>
                  }
                  {
                    w.editMode ? 
                    <TableCell><InputController error={errors.Advances} control={control} symbol="€" register={{ ...register('Advances') }} /></TableCell>
                    :
                    <TableCell onClick={function () { onRowClick(w.no) }}>
                      {new Intl.NumberFormat('en-GB', {
                        style: 'currency',
                        currency: 'EUR',
                      }).format(w.Advances)}
                    </TableCell>
                  }
                  {
                    w.editMode ? 
                    <TableCell><InputController error={errors.ExtraHours} control={control} register={{ ...register('ExtraHours') }} /></TableCell>
                    :
                    <TableCell onClick={function () { onRowClick(w.no) }}>{w.ExtraHours}</TableCell>
                  }
                  {
                    w.editMode ? 
                    <TableCell><InputController error={errors.HourSalary} control={control} symbol="€" register={{ ...register('HourSalary') }} /></TableCell>
                    :
                    <TableCell onClick={function () { onRowClick(w.no) }}>
                      {new Intl.NumberFormat('en-GB', {
                        style: 'currency',
                        currency: 'EUR',
                      }).format(w.HourSalary)}
                    </TableCell>
                  }
                  {
                    w.editMode ? 
                    <TableCell><InputController error={errors.Bonus} control={control} symbol="€" register={{ ...register('Bonus') }} /></TableCell>
                    :
                    <TableCell onClick={function () { onRowClick(w.no) }}>
                      {new Intl.NumberFormat('en-GB', {
                        style: 'currency',
                        currency: 'EUR',
                      }).format(w.Bonus)}
                    </TableCell>
                  }
                  <TableCell></TableCell>
                  <TableCell>
                    <ButtonGroup size="small">
                        <Button onClick={() => deleteRow(w.no)}>
                          <DeleteIcon />
                        </Button>
                        {salaries.length === index+1 && 
                          <Button onClick={() => addRow()}>
                            <AddIcon />
                          </Button> 
                        }
                    </ButtonGroup>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={salaries.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
        </div>
    )
}

export default MonthSalariesList